import { isNullable } from '@qtek/shared/utils';
import { FilterBase, FilterChangeBase } from './base';

interface ArrayOption {
  /** Translation key for that option. */
  name: string;

  /** Value of array option. */
  value: any;
}

export interface ArrayFilterValues {
  options?: ArrayOption[];
  selectedValue?: any[] | null;
}

export interface ArrayFilter extends FilterBase<ArrayFilterValues> {
  type: string;
  id: string;
  subId?: string;
  operation?: string;

  /** Determines how to compare values selected by valueAccessor and filter output. */
  compare?: (value: any, filterValue: any) => boolean;
}

export type ArrayFilterChange = FilterChangeBase<
  ArrayFilterValues,
  ArrayFilter
>;

/**
 * Filter function for arrays
 *
 * @param filters List of filter configurations
 * @param row Data for which the status is determined
 * @param valueAccessor Value access function
 */
export function arrayFilter<T>(
  filters: ArrayFilterChange[],
  row: T,
  valueAccessor: (row: T, id: string, subId?: string, type?: string) => any
): boolean {
  return filters.every(({ values, config }) => {
    if (isNullable(values.selectedValue) || !values.selectedValue.length) {
      return true;
    }

    if (config.type === 'array') {
      const rowValues = valueAccessor(
        row,
        config.id,
        config.subId,
        config.type
      );

      return values.selectedValue.some(
        selectedValue =>
          Array.isArray(rowValues) &&
          rowValues.some(rowValue =>
            config.compare
              ? config.compare(rowValue, selectedValue)
              : selectedValue === rowValue
          )
      );
    }

    return false;
  });
}
